"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = exports.Scrollable = exports.Content = exports.ContentMenu = exports.Title = exports.GuidedTourContainer = exports.GuidedTourBackground = exports.IconContainer = exports.MessageCenterContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.MessageCenterContainer = styled_components_1.default.div `
  position: relative;
  width: 100%;
`;
const guidedTourHighlightEffect = (0, styled_components_1.keyframes) `
  0% {
    box-shadow: 0 0 0 4px #c7c3f1;
  }

  25% {
    box-shadow: 0 0 0 4px #c7c3f1, 0 0 0 8px #c7c3f1;
  }

  50% {
    box-shadow: 0 0 0 4px #c7c3f1, 0 0 0 8px #dcdaf3;
  }

  75% {
    box-shadow: 0 0 0 4px #c7c3f1, 0 0 0 8px transparent;
  }

  100% {
    box-shadow: 0 0 0 4px #c7c3f1;
  }
`;
exports.IconContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;

  ${({ $isTransparent, theme }) => (0, styled_components_1.css) `
    color: ${$isTransparent ? theme.colors.white.s100 : theme.colors.text.body};

    & svg > path {
      fill: ${$isTransparent ? theme.colors.white.s100 : theme.colors.text.body};
    }
  `}

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    &::after {
      content: '';

      position: absolute;
      bottom: -${({ theme }) => theme.space.s050};
      left: 50%;

      display: block;
      width: 0;
      height: 2px;
      margin: 0 ${({ theme }) => theme.space.s200} 0 0;

      background: ${({ $isTransparent, theme }) => ($isTransparent ? theme.colors.white.s100 : theme.colors.main.base)};

      opacity: 0;
      transform: translateX(-50%);
    }

    &:hover {
      & svg path {
        fill: ${({ $isTransparent, theme }) => ($isTransparent ? theme.colors.white.s100 : theme.colors.main.base)};
      }

      &::after {
        width: 100%;

        opacity: 1;
        transition: all 150ms;
        transition-property: width, opacity;
      }
    }
  }
`;
exports.GuidedTourBackground = styled_components_1.default.div `
  position: absolute;
  top: 0;
  z-index: -1;

  width: ${({ theme }) => theme.space.s400};
  height: ${({ theme }) => theme.space.s400};

  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.guidedTour.base};
  animation: ${guidedTourHighlightEffect} 2s linear infinite;
`;
exports.GuidedTourContainer = styled_components_1.default.div `
  ${({ $guidedTourHighlight, theme }) => $guidedTourHighlight &&
    (0, styled_components_1.css) `
      svg > path {
        fill: ${theme.colors.white.s100};
      }
    `};
`;
exports.Title = styled_components_1.default.span `
  ${({ theme }) => (0, styled_components_1.css)(Object.assign(Object.assign({}, theme.typography.body.tinyTextMain), { fontWeight: theme.typography.body.regularTextMain.fontWeight }))};

  @media (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    display: none;
  }
`;
exports.ContentMenu = styled_components_1.default.div `
  @media screen and (max-width: ${({ theme }) => theme.breakpoint.tabletMedium}) {
    display: none;
  }
`;
const contentPositionLeft = (0, styled_components_1.css) `
  left: -${({ theme }) => theme.space.s600};
`;
const contentTransition = (0, styled_components_1.css) `
  &.header--menu-enter {
    ${contentPositionLeft};

    opacity: 0;
  }

  &.header--menu-enter-active {
    ${contentPositionLeft};

    opacity: 1;
    transition: opacity ease-in-out 200ms;
  }

  &.header--menu-exit {
    ${contentPositionLeft};

    opacity: 1;
  }

  &.header--menu-exit-active {
    ${contentPositionLeft};

    opacity: 0;
    transition: opacity ease-in-out 200ms;
  }
`;
exports.Content = styled_components_1.default.div `
  position: absolute;
  top: ${({ theme }) => theme.space.s800};
  ${contentPositionLeft};

  ${contentTransition};

  overflow-y: inherit;
  width: 298px;
  border: 1px solid ${({ theme }) => theme.colors.gray.s300};
  background-color: ${({ theme }) => theme.colors.neutral.n50};
  border-radius: ${({ theme }) => theme.radius.s100};
  transition: all 150ms;

  ::after,
  ::before {
    content: '';

    position: absolute;
    left: 4.75rem;

    height: 10px;
    border: 5px solid transparent;
    border-top: none;
    box-sizing: content-box;
  }

  ::after {
    top: -15px;

    border-bottom-color: ${({ theme }) => theme.colors.neutral.n50};
  }

  ::before {
    top: -16px;

    border-bottom-color: ${({ theme }) => theme.colors.gray.s300};
  }
`;
exports.Scrollable = styled_components_1.default.div `
  max-height: 613px;
  height: 100%;
  overflow-y: auto;
`;
exports.Anchor = styled_components_1.default.a `
  text-decoration: none;
  color: ${({ theme }) => theme.colors.neutral.n700};
`;
